if (!customElements.get('tsb-card-filter')) {
  class TsbCardFilter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-tsb-card-filter-input]');
      this.clearButton = this.querySelector('[data-tsb-card-filter-clear]');
      this.status = this.querySelector('[data-tsb-card-filter-status]');
      this.targetSelector = this.dataset.target || '[data-tsb-filter-grid]';
      this.cardSelector = this.dataset.card || '.f-column';
      this.titleSelector = this.dataset.titleSelector || '';
      this.scope = this.closest('[data-tsb-filter-scope]') || this.closest('.section') || document;
      this.filterTimer = null;

      if (!this.input) return;

      this.onInput = this.onInput.bind(this);
      this.onClear = this.onClear.bind(this);
      this.onRerender = this.onRerender.bind(this);

      this.input.addEventListener('input', this.onInput);
      this.clearButton && this.clearButton.addEventListener('click', this.onClear);
      document.addEventListener('collection:rerendered', this.onRerender);

      const searchTerm = new URL(window.location.href).searchParams.get('team_search');
      if (searchTerm) this.input.value = searchTerm;

      this.applyFilter(false);
    }

    disconnectedCallback() {
      this.input && this.input.removeEventListener('input', this.onInput);
      this.clearButton && this.clearButton.removeEventListener('click', this.onClear);
      document.removeEventListener('collection:rerendered', this.onRerender);
    }

    get grid() {
      return this.scope.querySelector(this.targetSelector) || document.querySelector(this.targetSelector);
    }

    get cards() {
      const grid = this.grid;
      if (!grid) return [];

      return Array.from(grid.children).filter((child) => child.matches(this.cardSelector));
    }

    onInput() {
      window.clearTimeout(this.filterTimer);
      this.filterTimer = window.setTimeout(() => this.applyFilter(true), 120);
    }

    onClear() {
      this.input.value = '';
      this.input.focus();
      this.applyFilter(true);
    }

    onRerender() {
      this.applyFilter(false);
    }

    getCardTitle(card) {
      const titleElement = this.titleSelector ? card.querySelector(this.titleSelector) : null;
      return (titleElement || card).textContent.trim();
    }

    sortCards() {
      const grid = this.grid;
      if (!grid) return;
      if (this.dataset.sort !== 'title' && grid.dataset.tsbFilterSort !== 'title') return;

      this.cards
        .sort((cardA, cardB) =>
          this.getCardTitle(cardA).localeCompare(this.getCardTitle(cardB), undefined, {
            numeric: true,
            sensitivity: 'base',
          })
        )
        .forEach((card) => grid.appendChild(card));
    }

    applyFilter(updateUrl) {
      const term = this.input.value.trim().toLowerCase();
      const cards = this.cards;
      let visibleCards = 0;

      this.sortCards();

      cards.forEach((card) => {
        const matches = !term || this.getCardTitle(card).toLowerCase().includes(term);
        card.hidden = !matches;
        card.classList.toggle('tsb-card-filter-hidden', !matches);
        if (matches) visibleCards += 1;
      });

      if (this.clearButton) this.clearButton.hidden = !term;

      if (this.status) {
        this.status.hidden = !term;
        this.status.textContent = visibleCards
          ? `Showing ${visibleCards} of ${cards.length} matches`
          : 'No teams match your search';
      }

      if (updateUrl) this.updateUrl(term);
      this.updateSlider();
    }

    updateUrl(term) {
      const url = new URL(window.location.href);
      if (term) {
        url.searchParams.set('team_search', term);
      } else {
        url.searchParams.delete('team_search');
      }
      history.replaceState({}, '', url.toString());
    }

    updateSlider() {
      const collectionList = this.grid && this.grid.closest('collection-list');
      const slider = collectionList && collectionList.sliderInstance && collectionList.sliderInstance.slider;
      if (slider && typeof slider.update === 'function') slider.update();
    }
  }

  customElements.define('tsb-card-filter', TsbCardFilter);
}
